export const ProductsModelModule = angular
    .module('app.services.model.models.productModel', [])
    .value('productModel', {
        availability: {
            preOrder: {
                enabled: ['Boolean', false]
            },
            message: ['String', null]
        },
        name: 'String',
        price: 'Number',
        pricing: {
            listPrice: 'Number',
            salePrice: 'Number'
        },
        msrp: 'Number',
        descriptions: {
            long: 'String',
            short: 'String',
            extended: 'String'
        },
        weight: 'Number',
        state: ['String', 'Active'],
        categoryIds: 'Array',
        contentPageId: ['String', null],
        seo: {
            title: 'String',
            metaDescription: 'String',
            friendlyName: 'String'
        },
        images: 'Array',
        revision: 'Number',
        sku: 'String',
        tenant: 'String',
        variantOptions: 'Array',
        productVariants: 'Array',
        requiresShipping: ['Boolean', true],
        isTaxable: ['Boolean', true],
        relatedProductIds: 'Array',
        taxCode: 'String'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/products.model.js